<template>
  <div class="termination-success" v-if="terminationResponse">
    <div class="termination-success--intro">
      <dyn-slot :slotData="slotData">
        <slot name="dynTxtIntro"></slot>
      </dyn-slot>
    </div>
    <div class="termination-success--customer-data">
      <div v-if="address.firstName"><strong><slot name="lblFirstName">Vorname:</slot></strong> <span>{{address.firstName}}</span><br></div>
      <div v-if="address.lastName"><strong><slot name="lblLastName">Nachname:</slot></strong> <span>{{address.lastName}}</span><br></div>
      <div v-if="address.street"><strong><slot name="lblStreet">Straße:</slot></strong> <span>{{address.street}}</span><br></div>
      <div v-if="address.houseNumber"><strong><slot name="lblHouseNumber">Hausnummer:</slot></strong> <span>{{address.houseNumber}}</span><br></div>
      <div v-if="address.zip"><strong><slot name="lblZip">Postleitzahl:</slot></strong> <span>{{address.zip}}</span><br></div>
      <div v-if="address.city"><strong><slot name="lblCity">Stadt:</slot></strong> <span>{{address.city}}</span><br></div>
      <div v-if="customer.email"><strong><slot name="lblEmail">E-Mail Adresse:</slot></strong> <span>{{customer.email}}</span><br></div>
      <div v-if="customer.terminationId.customerId"><strong><slot name="lblCustomerId">Kundennummer:</slot></strong> <span>{{customer.terminationId.customerId}}</span><br></div>
      <div v-if="customer.terminationId.msisdnOrContractId"><strong><slot name="lblContractId">Vertragsnummer:</slot></strong> <span>{{customer.terminationId.msisdnOrContractId}}</span><br></div>
      <div v-if="customer.terminationData.date"><strong><slot name="lblTerminationDate">Gewünschter Kündigungszeitpunkt:</slot></strong> <span>{{customer.terminationData.date}}</span><br></div>
      <div v-if="customer.terminationData.details"><strong><slot name="lblTerminationDetails">Details zur Kündigung:</slot></strong> <span class="wrap">{{customer.terminationData.details}}</span><br></div>
    </div>
    <div class="termination-success--closing">
      <slot name="txtClosing"></slot>
    </div>
    <div class="termination-success--download">
      <button @click="downloadDocument" class="filled" ><slot name="lblDownloadButton">Bestätigung speichern</slot></button>
    </div>
  </div>
</template>
<script>

import FileSaver from 'file-saver'
import appFileSaver from '@/mixins/appFileSaver'
import dateFormatter from '@/mixins/formatters/dateFormatter'
import { mapGetters } from 'vuex'

export default {
  name: 'TerminationSuccess',
  components: { },
  data  () {
    return { }
  },
  mounted () { },
  computed: {
    ...mapGetters('termination', {
      terminationResponse: 'terminationResponse'
    }),
    terminationDate () {
      return this.dateFormatter(new Date(this.terminationResponse.createdAt))
    },
    terminationTime () {
      return this.timeFormatter(new Date(this.terminationResponse.createdAt))
    },
    address () {
      return this.terminationResponse?.address || null
    },
    customer () {
      return this.terminationResponse?.customer || null
    },
    slotData () {
      return {
        date: this.terminationDate,
        time: this.terminationTime,
        caseNumber: this.terminationResponse.caseNumber
      }
    }
  },
  methods: {
    timeFormatter (datetime) {
      return this.$config.calendar.formatter.shortTimeFormatter.format(datetime)
    },
    downloadDocument (e) {
      e.preventDefault()
      const filename = 'Kündigungserklärung-' + this.terminationResponse.caseNumber + '.pdf'

      // decode base64 string, remove space for IE compatibility
      const binary = atob(this.terminationResponse.document.document.replace(/\s/g, ''))
      const len = binary.length
      const buffer = new ArrayBuffer(len)
      const blob = new Uint8Array(buffer)
      for (let i = 0; i < len; i++) {
        blob[i] = binary.charCodeAt(i)
      }
      const file = new Blob([blob], { type: 'application/octet-stream' })
      if (this.appTriggerSaveAsFileAvailable()) {
        this.appTriggerSaveAsFile(filename, file)
      } else {
        FileSaver.saveAs(file, filename)
      }
    }
  },
  mixins: [
    appFileSaver,
    dateFormatter
  ]
}
</script>
